import React from "react";
import "./Privacy_policy.css";

function PrivacyPolicy() {
  return (
    <div className="TodoPolicy">
      <div className="TodoPolicy-inner">
        <h1>プライバシーポリシー（ToDo）</h1>
        <p className="muted">
          ToDo（以下「本アプリ」）は、作田陽樹（以下「開発者」）が提供します。
          本アプリにおける利用者情報の取扱いについて、以下のとおり定めます。
        </p>

        <p className="muted">
          目次：1. 取得する情報 / 2. 利用目的 / 3. 第三者提供 / 4. 外部サービス / 5. 安全管理 / 6. 開示・訂正・削除 / 7. データの保存と削除
          / 8. 本ポリシーの変更 / 9. お問い合わせ / 10. 改定日
        </p>

        <h2>1. 取得する情報</h2>
        <p>開発者は、本アプリの提供にあたり、以下の情報を取得する場合があります（取得する場合は必要最小限とします）。</p>
        <ul>
          <li>
            <strong>アカウント情報</strong>：メールアドレス等（認証に必要な範囲）。
            パスワードは外部の認証基盤により処理され、開発者が平文で保持することはありません。
          </li>
          <li>
            <strong>アプリ内データ</strong>：タスク、プロジェクト等、利用者が本アプリ内で入力した内容。
          </li>
          <li>
            <strong>技術情報</strong>：不具合調査や改善のための端末情報（OS種別/バージョン、アプリバージョン等）やエラーログ等。
          </li>
        </ul>

        <h2>2. 利用目的</h2>
        <p>取得した情報は、以下の目的で利用します。</p>
        <ul>
          <li>本アプリの提供、本人確認、ログイン管理のため</li>
          <li>タスク等の保存、同期、表示等の機能提供のため</li>
          <li>不具合対応、品質改善、セキュリティ確保のため</li>
          <li>お問い合わせ対応、重要なお知らせの連絡のため</li>
          <li>不正利用防止・規約違反への対応のため</li>
        </ul>

        <h2>3. 第三者提供</h2>
        <p>
          開発者は、法令に基づく場合等を除き、利用者の同意なく個人情報を第三者へ提供しません。
          ただし、利用目的の達成に必要な範囲で取扱いを委託する場合があります。
        </p>

        <h2>4. 外部サービス（委託先）</h2>
        <p>
          本アプリは、データ保存・認証等のために外部サービスを利用することがあります。
          外部サービス提供者は、各社のプライバシーポリシーに従って情報を取り扱います。
        </p>

        <h2>5. 安全管理措置</h2>
        <p>開発者は、情報の漏えい、滅失、毀損等を防止するため、アクセス制御等の合理的な安全管理措置を講じます。</p>

        <h2>6. 開示・訂正・削除等</h2>
        <p>
          利用者は、法令の範囲内で、保有個人データの開示、訂正、利用停止、削除等を求めることができます。 具体的な手続は「9.
          お問い合わせ」記載の窓口へご連絡ください。
        </p>

        <h2>7. データの保存と削除（アプリ削除/アカウント削除）</h2>
        <p>
          本アプリは、機能提供の都合上、利用者の入力したタスク等のデータを外部サービス上に保存する場合があります。 そのため、
          <strong>端末からアプリを削除しただけでは、外部サービス上のデータが残る場合があります</strong>。
        </p>
        <p>
          データの削除を希望する場合は、本アプリの「設定」等からアカウント削除を実行するか、 実行できない場合は「9.
          お問い合わせ」へご連絡ください。
        </p>

        <h2>8. 本ポリシーの変更</h2>
        <p>開発者は、必要に応じて本ポリシーを変更します。変更後の内容は、本ページ等の適切な方法で周知します。</p>

        <h2>9. お問い合わせ</h2>
        <p>
          本アプリに関するお問い合わせは、以下へご連絡ください。
          <br />
          個人情報取扱い責任者：作田陽樹
          <br />
          メールアドレス：haruki2021promoter@gmail.com
        </p>

        <h2>10. 改定日・制定日</h2>
        <p>
          改定日：2026年1月11日
          <br />
          制定日：2026年1月11日
        </p>

        <p className="muted">
          ※ 本アプリは現時点で<strong>課金機能や広告配信</strong>を実装していません。
          ただし、今後これらの機能を追加する場合があり、その際は本ポリシーを更新します。
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
